import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import './plugins/vuetify'
import { firebaseApp } from './plugins/firebase'

import App from './App.vue'

import { router } from './router/index'
import store from './store/store'
import './registerServiceWorker'

import { mapActions } from 'vuex'

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.component('multiselect', Multiselect)

new Vue({
  data () {
    return {
      firebaseApp: null
    }
  },
  router,
  store,
  render: h => h(App),
  async created () {
    this.firebaseApp = firebaseApp
    await this.checkUserState()
    // await subscribeToNotifications()
  },
  methods: {
    ...mapActions('authentication', ['getFromLocalStorage']),
    checkUserState: async function () {
      await this.getFromLocalStorage()
    }
  }
}).$mount('#app')
